<form class='upgradeform custom-form   mw-full  m-l-a m-r-a p-20' [formGroup]="registerForm"
    (ngSubmit)="onRegisterFormSubmit()">
    <div *ngIf="data.from=='opp'" class='t-c info m-t-20'>You are registered as a <span class='strong'>listener</span>
        <br>
        To participate in this opportunity, your profile needs to be updated to an <span class='strong'>artist
            profile</span>. Please fill the below details to proceed:
    </div>
    <div *ngIf="data.from=='settings'" class='t-c strong f16'>Upgrade to Artist Profile</div>
     <div *ngIf="data.from=='upload'" class='t-c info m-t-20'>You are registered as a <span class='strong'>listener</span>
        <br>
        To upload any content, your profile needs to be updated to an <span class='strong'>artist
            profile</span>. Please fill the below details to proceed:
    </div>

    <div class="artistdetail" id="form2">
        <div class="details">
            <div class="d-flex flex-row justify-content-between mt-4 px-5">

                <div class="pt-2 labels">I am a/an</div>
                <div class="radio">
                    <input id="radio-1" type="radio" value="Artist" formControlName="is_type"
                        (click)="global.trackEvent('Registration', 'Option-Artist');">
                    <label for="radio-1" class="radio-label">Artist</label>
                </div>

                <div class="radio">
                    <input id="radio-2" type="radio" value="Band" formControlName="is_type"
                        (click)="global.trackEvent('Registration', 'Option-Band');">
                    <label for="radio-2" class="radio-label">Band</label>
                </div>
            </div>
            <mat-error *ngIf="formSubmit && registerForm.errors?.required" class="f10"
                style="text-align:left;font-weight: bold;">
                Please select one
            </mat-error>

            <div class="margin-flex">
                <div class="m-0 p-0 form-group" style="width: 100%;">
                    <div class="labels">{{registerForm.value.is_type == "" ? "Artist/Band" : registerForm.value.is_type
                        ==
                        "Artist" ? "Artist" : "Band"}} Name*</div>
                    <input
                        [ngClass]="{ 'is-invalid':fname.errors?.required || fname.errors?.validSongTitle || fname.errors?.maxlength}"
                        class="m-0 form-control" type='text' formControlName="fname" placeholder="{{registerForm.value.type ==
                        'Artist' ? 'Artist' : 'Band'}} Name" required>

                    <mat-error *ngIf="fname.errors?.required ">
                        Please enter your {{registerForm.value.is_type == "" ? "Artist/Band" :
                        registerForm.value.is_type ==
                        "Artist" ? "Artist" : "Band"}} Name
                    </mat-error>
                    <mat-error *ngIf="!fname.errors?.required && fname.errors?.validSongTitle">
                        Please enter a valid {{registerForm.value.is_type == "" ? "Artist/Band" :
                        registerForm.value.is_type
                        ==
                        "Artist" ? "Artist" : "Band"}} Name
                    </mat-error>

                    <mat-error
                        *ngIf="formSubmit && fname.errors?.maxlength && !fname.errors?.validSongTitle && !fname.errors?.required">
                        {{registerForm.value.is_type == "" ? "Artist/Band" : registerForm.value.is_type == "Artist" ?
                        "Artist"
                        :
                        "Band"}} Name can't be more than 50
                        characters long
                    </mat-error>
                </div>


            </div>


            <div class="margin-flex ">
                <div class="m-0 p-0 form-group" style="width: 100%;">
                    <div class="labels">User Name/Profile URL*</div>
                    <input class="m-0 form-control" id='username' disabled placeholder="Enter User Name/Profile URL"
                        type='text' formControlName="username" required>

                </div>

            </div>


            <div class="margin-flex">
                <div class="m-0 p-0 form-group" style="width: 100%;">
                    <div class="labels">Mobile Number*</div>
                    <input class="m-0 form-control" type='tel' formControlName="mobile" placeholder="Mobile Number"
                        (keypress)="keyPressNumbers($event)"
                        [ngClass]="{ 'is-invalid':mobile.errors?.validMobile && mobile.errors?.dirty || mobile.errors?.maxlength || mobile.errors?.pattern || (formSubmit && mobile.errors?.required)}">
                    <mat-error *ngIf="mobile.errors?.pattern ||  mobile.errors?.maxlength ">
                        Please enter a valid mobile number
                    </mat-error>
                    <mat-error *ngIf="formSubmit && mobile.errors?.required  ">
                        Please enter mobile number
                    </mat-error>

                </div>
            </div>


            <div style="margin-bottom: 12px">
                <div class="m-0 p-0 form-group " style="width: 100%;">
                    <div class="labels">Email*</div>
                    <input class="m-0 form-control" id='email' type='email' formControlName="email"
                        placeholder="Your Email" disabled
                        [ngClass]="{ 'is-invalid':(email.dirty || email.touched) && (email.errors?.required || email.errors?.email ||email.errors?.pattern || email.errors?.emailExists ) }"
                        [readonly]="register.update && register.email!='' && register.email!=null && register.email!=undefined"
                        required>

                    <mat-error *ngIf="(email.dirty || email.touched) && email.errors?.required ">
                        Please enter your email ID
                    </mat-error>
                    <mat-error *ngIf="!email.errors?.required && email.dirty && email.errors?.email">
                        Please enter a valid email ID
                    </mat-error>
                    <mat-error
                        *ngIf="!email.errors?.required && email.dirty && !email.errors?.email && email.errors?.pattern">
                        Please enter a valid email ID
                    </mat-error>
                    <mat-error
                        *ngIf="!email.errors?.required && email.dirty && !email.errors?.email && !email.errors?.pattern && email.errors?.emailExists">
                        The Email ID entered already exist
                    </mat-error>
                </div>
            </div>
            <!-- 
            <div class="tc" sty>
                By Signing Up, you agree to the <a routerLink="/about/terms-of-use" target="_blank">terms&conditions</a>
                and <a routerLink="/about/privacy-policy" target="_blank">privacy policy</a> of Songdew
            </div> -->

            <mat-error class='col-xs-12 t-c ' *ngIf="registerError">{{registerErrorMsg}}</mat-error>

            <div class="col-xs-12 form-group t-c ">
                <button type="submit" [disabled]="registerLoading">{{(registerLoading)?'Processing':'Update'}}</button>
            </div>

        </div>
    </div>







    <!-- <div class='row m-t-10'>
        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" [hideRequiredMarker]="false">
            <input matInput type='text' placeholder="First name" formControlName="fname" required>
            <mat-error *ngIf="fname.errors?.required">
                Please enter your First name
            </mat-error>
            <mat-error *ngIf="!fname.errors?.required && fname.errors?.validSongTitle">
                Please enter a valid first name
            </mat-error>
            <mat-error *ngIf="fname.errors?.minlength && !fname.errors?.validSongTitle && !fname.errors?.required">
                First name must be atleast 1 character long
            </mat-error>
            <mat-error *ngIf="fname.errors?.maxlength && !fname.errors?.validSongTitle && !fname.errors?.required">
                First name can't be more than 50 characters long
            </mat-error>
        </mat-form-field>

      <mat-form-field class="col-xs-12 col-sm-6 m-t-10">
            <input matInput type='text' placeholder="Last Name" formControlName="lname">
            <mat-error *ngIf="lname.errors?.maxlength">
                Last name can't be more than 50 characters long
            </mat-error>
        </mat-form-field> 

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" [hideRequiredMarker]="false">
            <input id='email' matInput type='email' placeholder="Email" formControlName="email"
                [readonly]="user.email!='' && user.email!=null && user.email!=undefined" required>
            <mat-error *ngIf="email.errors?.required">
                Please enter your email ID
            </mat-error>
            <mat-error *ngIf="!email.errors?.required && email.dirty && email.errors?.email">
                Please enter a valid email ID
            </mat-error>
            <mat-error *ngIf="!email.errors?.required && email.dirty && !email.errors?.email && email.errors?.pattern">
                Please enter a valid email ID
            </mat-error>
        </mat-form-field>

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" floatLabel="never" [hideRequiredMarker]="false">
            <div style="position: absolute; left: -98px; -webkit-transform: translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px);
            transform: translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px);
            -ms-transform: translateY(-1.28125em) scale(.75);">Username (Profile URL)</div>
            <input id='username' matInput type='text' placeholder="username" formControlName="username"
                [readonly]="user.slug!='' && user.slug!=undefined && user.slug!=null" required>
            <span matPrefix class='placeholderColor f12'>Songdew.com/</span>
            <mat-error *ngIf="username.errors?.required">
                Please choose a username
            </mat-error>
            <mat-error *ngIf="!username.errors?.required && username.errors?.validSongTitle">
                Please enter a valid username
            </mat-error>
            <mat-error
                *ngIf="username.errors?.minlength && !username.errors?.validSongTitle && !username.errors?.required">
                Username must be atleast 3 characters long
            </mat-error>
            <mat-error
                *ngIf="username.errors?.maxlength && !username.errors?.validSongTitle && !username.errors?.required">
                Username can't be more than 50 characters long
            </mat-error>
        </mat-form-field>

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" [hideRequiredMarker]="false">
            <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="Primary Genre"
                formControlName="genre" required>
                <mat-option *ngFor="let genre of genres" [value]="genre.name">
                    {{genre.name}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="genre.errors?.required">
                Please select your primary genre
            </mat-error>
        </mat-form-field>

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10">
            <input matInput type='text' placeholder="Mobile" formControlName="mobile">
            <mat-error *ngIf="mobile.errors?.validMobile">
                Please enter a valid 10 digit mobile number
            </mat-error>
        </mat-form-field>

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" [hideRequiredMarker]="false">
            <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="Country" formControlName="country"
                (selectionChange)="countryChanged()" required>
                <mat-option *ngFor="let countryValue of countries" [value]="countryValue.name">
                    {{countryValue.name}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="country.errors?.required">
                Please select your country
            </mat-error>
        </mat-form-field>

        <div [class.col-xs-12]="registerForm.value.state=='Other' || global.isMobile()"
            [class.col-xs-6]="!(registerForm.value.state=='Other' || global.isMobile())">
            <div class="row">
                <mat-form-field [class.col-xs-6]="registerForm.value.state=='Other' || global.isMobile()"
                    [class.col-xs-12]="!(registerForm.value.state=='Other' || global.isMobile())" class="m-t-10"
                    [hideRequiredMarker]="false">
                    <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="State"
                        formControlName="state" (selectionChange)="stateChanged()" required>
                        <mat-option *ngFor="let state of states" [value]="state.name">
                            {{state.name}}
                        </mat-option>
                        <mat-option *ngIf="registerForm.value.country!=''" value="Other">Other</mat-option>
                    </mat-select>
                    <mat-error *ngIf="state.errors?.required">
                        Please select your state
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="registerForm.value.state=='Other'"
                    [class.col-xs-6]="registerForm.value.state=='Other' || global.isMobile()"
                    [class.col-xs-12]="!(registerForm.value.state=='Other' || global.isMobile())" class="m-t-10"
                    [hideRequiredMarker]="false">
                    <input matInput type='text' placeholder="State Name" formControlName="otherState" required>
                    <mat-error *ngIf="otherState.errors?.required">
                        Please enter your state
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div [class.col-xs-12]="registerForm.value.city=='Other' || global.isMobile()"
            [class.col-xs-6]="!(registerForm.value.city=='Other' || global.isMobile())">
            <div class="row">
                <mat-form-field [class.col-xs-6]="registerForm.value.city=='Other' || global.isMobile()"
                    [class.col-xs-12]="!(registerForm.value.city=='Other' || global.isMobile())" class="m-t-10"
                    [hideRequiredMarker]="false">
                    <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="City"
                        formControlName="city" required>
                        <mat-option *ngFor="let city of cities" [value]="city.name">
                            {{city.name}}
                        </mat-option>
                        <mat-option *ngIf="registerForm.value.state!=''" value="Other">Other</mat-option>
                    </mat-select>
                    <mat-error *ngIf="city.errors?.required">
                        Please select your city
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="registerForm.value.city=='Other'"
                    [class.col-xs-6]="registerForm.value.city=='Other' || global.isMobile()"
                    [class.col-xs-12]="!(registerForm.value.city=='Other' || global.isMobile())" class="m-t-10"
                    [hideRequiredMarker]="false">
                    <input matInput type='text' placeholder="City Name" formControlName="otherCity" required>
                    <mat-error *ngIf="otherCity.errors?.required">
                        Please enter your city
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" [hideRequiredMarker]="false">
            <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="State" formControlName="state"
                (selectionChange)="stateChanged()" required>
                <ng-container *ngFor="let state of states">
                    <mat-option *ngIf="state.name!='Other'" [value]="state.name">
                        {{state.name}}
                    </mat-option>
                </ng-container>
                <mat-option *ngIf="registerForm.value.country!=''" value="Other">Other</mat-option>
            </mat-select>
            <mat-error *ngIf="state.errors?.required">
                Please select your state
            </mat-error>
        </mat-form-field>

        <div [class.col-xs-12]="((registerForm.value.state!='Other' || cities.length>0) && registerForm.value.city=='Other') || global.isMobile()"
            [class.col-xs-6]="!(((registerForm.value.state!='Other' || cities.length>0) && registerForm.value.city=='Other') || global.isMobile())">
            <div class="row">
                <mat-form-field *ngIf="registerForm.value.state!='Other' || cities.length>0"
                    [class.col-xs-6]="((registerForm.value.state!='Other' || cities.length>0) && registerForm.value.city=='Other') || global.isMobile()"
                    [class.col-xs-12]="!(((registerForm.value.state!='Other' || cities.length>0) && registerForm.value.city=='Other') || global.isMobile())"
                    class="m-t-10" [hideRequiredMarker]="false">
                    <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="City"
                        formControlName="city" required>
                        <ng-container *ngFor="let city of cities">
                            <mat-option *ngIf="city.name!='Other'" [value]="city.name">
                                {{city.name}}
                            </mat-option>
                        </ng-container>
                        <mat-option *ngIf="registerForm.value.state!=''" value="Other">Other</mat-option>
                    </mat-select>
                    <mat-error *ngIf="city.errors?.required">
                        Please select your city
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    *ngIf="registerForm.value.city=='Other' || (registerForm.value.state=='Other' && cities.length==0)"
                    [class.col-xs-6]="((registerForm.value.state!='Other' || cities.length>0) && registerForm.value.city=='Other') || global.isMobile()"
                    [class.col-xs-12]="!(((registerForm.value.state!='Other' || cities.length>0) && registerForm.value.city=='Other') || global.isMobile())"
                    class="m-t-10" [hideRequiredMarker]="false">
                    <input matInput type='text' placeholder="City Name" formControlName="otherCity" required>
                    <mat-error *ngIf="otherCity.errors?.required">
                        Please enter your city
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <mat-form-field class="col-xs-12 col-sm-6 m-t-10" [hideRequiredMarker]="false">
            <mat-select disableOptionCentering panelClass="myPanelClass" placeholder="Fields of Expertise"
                formControlName="artistType" multiple required>
                <mat-option *ngFor="let type of artistTypes" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
            <mat-hint>Maximum 3 fields can be selected</mat-hint>
            <mat-error *ngIf="artistType.errors?.required">
                Please select atleast 1 field
            </mat-error>
            <mat-error *ngIf="!artistType.errors?.required && artistType.errors?.validArtistTypes">
                Maximum 3 fields can be selected
            </mat-error>
        </mat-form-field>

        <div class="col-xs-12 t-c m-t-20 f13">
            By clicking 'Register', you agree to Songdew
            <a routerLink="/about/terms-of-use" target="_blank" class="linkBlue">Terms of Use</a> and
            <a routerLink="/about/privacy-policy" target="_blank" class="linkBlue">Privacy Policy</a>.
        </div>

        <div class='col-xs-12 t-c text-danger m-t-20' *ngIf="registerError">{{registerErrorMsg}}</div>

        <div class="col-xs-12 form-group t-c m-t-20">
            <button type="submit" class=''
                [disabled]="registerLoading">{{(registerLoading)?'Processing':'Update'}}</button>
        </div>
    </div> -->
</form>
